import { GlobalError } from "react-hook-form";
export const useFormValidate = () => {
  const validateField = (error: GlobalError | undefined, minLength = 0, maxLength = 0): string => {
    if (error?.type === "validate" || error?.type === "pattern") {
      return "El dato ingresado es inválido";
    } else if (minLength > 0 && error?.type === "minLength") {
      return `Debe contener al menos ${minLength} de longitud`;
    } else if (error?.type === "required") {
      return "Este campo es requerido";
    } else if (maxLength !== 0 && error?.type === "maxLength") {
      return `No puede contener más de ${maxLength} de longitud`;
    }
    return "";
  };
  return {
    validateField
  };
};